export default __webpack_public_path__ + "static/media/weather_04.9792c63b.png";